import { resolvePermissionCheck } from "@/utils/groupPermissions";

/**
 * Permissions required to read and write every object touched during onboarding.
 * Entity reads are open to authenticated users; writes use configure_entity.
 */
export const ONBOARDING_REQUIRED_PERMISSIONS = [
    "core.configure_entity",
    "stock.view_stock",
    "stock.add_stock",
    "stock.change_stock",
    "stock.delete_stock",
    "core.view_deliverysite",
    "core.add_deliverysite",
    "core.change_deliverysite",
    "core.delete_deliverysite",
];

/**
 * @param {string[]} userPermissions
 * @param {{ readonly?: boolean }} [options]
 * @returns {boolean}
 */
export function canAccessOnboarding(userPermissions, options = {}) {
    if (options.readonly) {
        return false;
    }
    if (!Array.isArray(userPermissions) || userPermissions.length === 0) {
        return false;
    }
    return ONBOARDING_REQUIRED_PERMISSIONS.every((perm) =>
        resolvePermissionCheck(userPermissions, perm)
    );
}
